import { SVButton } from '@/components/core';
import { useState } from 'react';
import BankApplicationDeleteDialog from '../BankApplicationDeleteDialog';
import {
  BankApplicationDetails,
  BankApplicationStatus,
} from '@/types/bankApplications';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import BankApplicationVerifyExternalAccountsDialog from '../BankApplicationVerifyExternalAccountsDialog';

type BankApplicationDetailsButtonsProps = {
  bankApplication: BankApplicationDetails;
};

export default function BankApplicationDetailsButtons({
  bankApplication,
}: BankApplicationDetailsButtonsProps) {
  const navigate = useNavigate();
  const { isStaff } = useAuthUser();
  const [openDelete, setOpenDelete] = useState(false);
  const [openVerify, setOpenVerify] = useState(false);
  const { status, uuid, applicationId, primaryOwner } = bankApplication;

  const isCompleted =
    status === BankApplicationStatus.COMPLETED ||
    status === BankApplicationStatus.DECLINED;

  if (isCompleted) {
    return null;
  }

  const isEditable =
    status === BankApplicationStatus.DRAFT ||
    status === BankApplicationStatus.NEED_REVIEW;
  const showVerifyExternalAccounts =
    status === BankApplicationStatus.EXTERNAL_ACCOUNT_REVIEW && isStaff;

  return (
    <>
      <SVButton onClick={() => setOpenDelete(true)} variant="error">
        Delete
      </SVButton>
      {showVerifyExternalAccounts && (
        <SVButton onClick={() => setOpenVerify(true)} variant="success">
          Verify External Accounts
        </SVButton>
      )}
      {isEditable && (
        <SVButton
          onClick={() =>
            navigate(`${ROUTES.BANK_ACCOUNT_APPLICATIONS}/${uuid}/edit`)
          }>
          Edit
        </SVButton>
      )}
      <BankApplicationDeleteDialog
        uuid={uuid}
        applicationId={applicationId}
        ownerName={primaryOwner?.consumer.fullName || ''}
        open={openDelete}
        setOpen={setOpenDelete}
        navigateRoute={ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT}
      />
      <BankApplicationVerifyExternalAccountsDialog
        uuid={uuid}
        applicationId={applicationId}
        ownerName={primaryOwner?.consumer.fullName || ''}
        open={openVerify}
        setOpen={setOpenVerify}
      />
    </>
  );
}
